import Image from "next/image";
import { ShoppingBag } from "lucide-react";
import { BlockProps } from "../BlocksManager/registry";
import Link from "next/link";

function renderMarkedTitle(title: string, highlightClass: string) {
  const parts = title.split(/(\[.*?\])/g);

  return parts.map((part, index) => {
    const isHighlighted = part.startsWith("[") && part.endsWith("]");

    if (isHighlighted) {
      const text = part.slice(1, -1);

      return (
        <span
          key={index}
          className={`inline-block font-heading -rotate-1 rounded-lg my-2 uppercase tracking-widest px-3 py-0.5 text-[36px]  text-white ${highlightClass}`}
        >
          {text}
        </span>
      );
    }

    return <span key={index}>{part}</span>;
  });
}

export default function Cta({ data }: BlockProps) {
  if (!data || !data.cta || !data.image) return null;
  
  return (
    <section className="relative -mb-44 py-10" key={data.id}>
      <div className="relative mx-auto max-w-[80%] shadow-2xl overflow-hidden rounded-[28px] bg-yellow-light min-h-[400px] lg:min-h-[572px]">
        <div className="absolute -left-[14px] -top-[6px] h-[140px] w-[96px] rounded-r-full bg-yellow" />
        <div className="absolute left-[35%] top-[10px] lg:top-[72px] h-[64px] w-[64px] rounded-full bg-yellow" />
        <div className="hidden lg:block absolute lg:right-[35%] right-[-25%] top-[420px] lg:top-[97px] h-[238px] w-[238px] rounded-full bg-yellow" />
        <div className="hidden lg:block absolute bottom-0 left-[40px] lg:bottom-[-74px] lg:left-[27%] h-[168px] w-[290px] rounded-t-full bg-yellow" />
        <div className="absolute bottom-[92px] right-[66px] h-[30px] w-[30px] rounded-full bg-yellow" />

        <div className="relative z-10 grid grid-cols-1 justify-center lg:min-h-[570px] lg:grid-cols-[0.9fr_1.1fr]">
          <div className="flex flex-col min-h-[400px] justify-center items-start px-8 py-8 md:px-12 lg:px-[82px]">
            <h2 className="font-literata text-[40px] lg:text-[60px] font-bold leading-none text-text-body md:text-[40px] lg:text-[48px]">
              {renderMarkedTitle(data.titre, "bg-pink")}
            </h2>

            <p className="mb-8 max-w-[640px] text-lg text-text-body font-body">{data.description}</p>
            
            <Link
              href={process.env.NEXT_PUBLIC_STRAPI_COMMANDE_ENDPOINT || "#"}
              className="inline-flex items-center gap-3 rounded-full px-7 py-4 text-[20px] font-semibold text-black transition bg-yellow"
            >
              <ShoppingBag className="ml-2 h-5 w-5" />
              {data.cta.text}
            </Link>
          </div>

          <div className="relative hidden md:block lg:min-h-full">
            <div className="absolute bottom-0 right-0 h-full w-full">
              <Image
                src={data.image.url}
                alt="Livreuse Régalice"
                fill
                className="absolute -bottom-0.5 right-10 h-[108%] w-full max-w-none object-contain object-bottom-right"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
